module.exports = __webpack_public_path__ + "images/default_avatars/winter-764fab25f4946afc3e131cfc5e835270.jpg";